import React from 'react'

const SpeechBubbleOutlineIcon = () => {
	return (
		<svg width={33} height={32} viewBox='0 0 33 32' fill='none' xmlns='http://www.w3.org/2000/svg'>
			<path
				clipRule='evenodd'
				d='M1.468 18.87V6.65C1.468 3.5 3.841 1 6.718 1h19.5c2.928 0 5.25 2.553 5.25 5.65v12.22c0 3.15-2.372 5.65-5.25 5.65H14.022s-7.304 6.845-7.708 6.465c-.27-.255 1.142-6.524 1.142-6.524l-1.747-.104c-2.423-.489-4.24-2.77-4.24-5.487z'
				stroke='currentColor'
				strokeWidth={1.5}
			/>
			<path
				d='M7.093 7.563h18.75M7.093 13.188h18.75M7.093 18.813h18.75'
				stroke='currentColor'
				strokeWidth={1.5}
			/>
		</svg>
	)
}

export default SpeechBubbleOutlineIcon
